import { RateLimiterSettings } from "./rate_limiter";
import { compressedJSON } from "./jsonify";

const APICall = (storage, clientOptions) => {
  let fetchPromise = null;
  let resendJobInProgress = false;

  const send = (batchData) => {
    let batchJSON = compressedJSON(batchData);
    return fetch(clientOptions.gatewayURL, {
      method: "POST",
      body: batchJSON,
      keepalive: clientOptions.keepAlive,
      headers: {
        "x-scribe-source": clientOptions.scribeSource,
        "x-token-type": clientOptions.xTokenType,
        "x-token": clientOptions.xToken,
      },
    });
  };

  const resendIfFail = (resendCount = 0) => {
    // when resendIfFail is called for the first time by debounce and there is another resendIfFail recursion still ongoing
    if (resendCount == 0 && resendJobInProgress) return fetchPromise;
    if (storage.empty()) return fetchPromise;

    let batchData = storage.array();
    storage.clear();

    fetchPromise = send(batchData)
      .then((response) => {
        resendJobInProgress = false;
        return response;
      })
      .catch((err) => {
        if (resendCount < RateLimiterSettings.maxResend) {
          resendJobInProgress = true;

          for (let i = 0; i < batchData.length; i++) storage.push(batchData[i]);

          setTimeout(() => {
            resendIfFail(++resendCount);
          }, RateLimiterSettings.resendTimeout * (resendCount + 1));
        } else {
          resendJobInProgress = false;
        }
        return err;
      });

    return fetchPromise;
  };

  const getVariable = (varRequestObj) => {
    if (typeof varRequestObj.reqBody !== "object")
      throw Error("Get Variable request body must be an object");
    if (varRequestObj.service === undefined)
      throw Error("Get variable call missing service name");

    const serviceName = varRequestObj.service;
    const fetchUrl =
      clientOptions.transmitterURL + "/" + serviceName + "/webVariable/";
    const reqBodyJSON = JSON.stringify(varRequestObj.reqBody);

    return fetch(fetchUrl, {
      method: "POST",
      body: reqBodyJSON,
      keepalive: clientOptions.keepAlive,
      headers: {
        "x-scribe-source": clientOptions.scribeSource,
      },
    })
      .then((response) => response.json())
      .then((respJson) => respJson)
      .catch((err) => {
        throw Error(
          `GetVariable call failed for variable: ${varRequestObj.reqBody.var} with error: ${err}`
        );
      });
  };

  return Object.freeze({
    resendIfFail,
    getVariable,
  });
};

export { APICall };
